export default {
  title: 'Näyttää siltä, että olet offline-tilassa',
  description:
    'Napsauta "Lataa sivu uudelleen" ja/tai tarkista internetyhteytesi varmistaaksesi, että olet verkossa 😊',
  custom_button: {
    reload: 'Lataa sivu uudelleen',
  },
};
